<template>
  <aside
    class="bg-surface-default-low border-static-default-low flex flex-col border-r lg:w-224 lg:shrink-0"
  >
    <div class="grow p-16">
      <div class="flex items-center gap-12">
        <RevAvatar
          aria-hidden="true"
          class="mood-emerald shrink-0"
          :label="avatarLabel"
          size="medium"
          :thumbnail="IconShop"
        />
        <span class="hidden truncate lg:inline">
          {{ avatarLabel }}
        </span>
      </div>
    </div>

    <nav
      class="border-static-default-low z-10 flex flex-col gap-6 border-b px-16 py-18 lg:gap-0 lg:px-0 lg:py-[15px]"
    >
      <NavItem
        :icon="IconArchive"
        :text="i18n(translations.allRequests)"
        :to="{ name: ROUTE_NAMES.CUSTOMER_CARE.ALL_REQUESTS }"
      />

      <NavItem
        :icon="IconMegaphone"
        target="_blank"
        :text="i18n(translations.feedback)"
        :to="feedbackUrl"
      />

      <NavItem
        :icon="IconUndo"
        :text="i18n(translations.back)"
        :to="{ name: ROUTE_NAMES.HOME.INDEX }"
      />

      <NavItem
        v-if="isImpersonated"
        destructive
        :icon="IconLogOut"
        :text="i18n(translations.leaveSellerView)"
        :to="{ name: ROUTE_NAMES.BADOOM.HOME, query: { mid: 's' } }"
      />
    </nav>

    <LanguageSelector />
  </aside>
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { useI18nLocale } from '@backmarket/nuxt-module-i18n/useI18nLocale'
import { RevAvatar } from '@ds/components/Avatar'
import { IconArchive } from '@ds/icons/IconArchive'
import { IconLogOut } from '@ds/icons/IconLogOut'
import { IconMegaphone } from '@ds/icons/IconMegaphone'
import { IconShop } from '@ds/icons/IconShop'
import { IconUndo } from '@ds/icons/IconUndo'

import { ROUTE_NAMES } from '~/constants/routes'
import { useSellerInfoStore } from '~/scopes/auth/stores/sellerInfoStore'

import { feedbackUrlFallback, feedbackUrls } from './Sidebar.constants'
import translations from './Sidebar.translations'
import LanguageSelector from './components/LanguageSelector/LanguageSelector.vue'
import NavItem from './components/NavItem/NavItem.vue'

const i18n = useI18n()
const currentLocale = useI18nLocale()

const { isImpersonated, companyName } = useSellerInfoStore()

const avatarLabel = companyName || i18n(translations.welcome)

const lang = currentLocale.split('-')[0]
const feedbackUrl = feedbackUrls[lang] || feedbackUrlFallback
</script>
